import { router as myQuizzes } from './my-quizzes';
import { router as videoLectures } from './video-lectures';
import { router as videoCourses } from './video-courses';
import { router as assignments } from './assignments';
import { router as publishers } from './publishers';
import { router as myCards } from './my-cards';
import { router as editPage } from './edit-page';
import { router as auth } from './auth';
import library from './library';
import errors from './errors';

export default [
  ...myQuizzes,
  ...videoLectures,
  ...videoCourses,
  ...assignments,
  ...publishers,
  ...myCards,
  ...library,
  ...auth,
  ...errors,
  ...editPage,
];



// WEBPACK FOOTER //
// ./src/app/router.js